(() => {
  const GALLERY_SELECTOR = 'gp-product-images-v3';
  const CUSTOM_ID = 'vayana-print-gallery';

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

  function getSelectedPrint() {
    const selectedOption = document.querySelector(
      'select option[option-data="Print"]:checked'
    );

    if (selectedOption) {
      return selectedOption.textContent.trim();
    }

    const printSelect = Array.from(document.querySelectorAll('select')).find(
      (select) =>
        Array.from(select.options).some(
          (option) =>
            normalize(option.getAttribute('option-data')) === 'print'
        )
    );

    return (
      printSelect?.options[printSelect.selectedIndex]?.textContent.trim() || ''
    );
  }

  function getImageSource(image) {
    return (
      image.currentSrc ||
      image.getAttribute('src') ||
      image.getAttribute('data-src') ||
      ''
    );
  }

  function collectImages(nativeGalleries) {
    const seen = new Set();
    const images = [];

    nativeGalleries.forEach((gallery) => {
      gallery.querySelectorAll('img[alt]').forEach((image) => {
        const print = image.getAttribute('alt')?.trim();
        const src = getImageSource(image);

        if (!print || !src) return;

        const key = `${normalize(print)}|${src.split('?')[0]}`;

        if (seen.has(key)) return;
        seen.add(key);

        images.push({
          print,
          src,
          srcset: image.getAttribute('srcset') || '',
        });
      });
    });

    return images;
  }

  function addStyles() {
    if (document.getElementById('vayana-print-gallery-styles')) return;

    const style = document.createElement('style');
    style.id = 'vayana-print-gallery-styles';

    style.textContent = `
      ${GALLERY_SELECTOR}.vayana-native-hidden {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        overflow: hidden !important;
      }

      #${CUSTOM_ID} {
        display: grid;
        grid-template-columns: 82px minmax(0, 1fr);
        gap: 14px;
        width: 100%;
        align-items: start;
      }

      #${CUSTOM_ID} .vayana-main {
        grid-column: 2;
        grid-row: 1;
        width: 100%;
      }

      #${CUSTOM_ID} .vayana-main img {
        display: block;
        width: 100%;
        height: auto;
        aspect-ratio: 4 / 5;
        object-fit: cover;
        border-radius: 10px;
      }

      #${CUSTOM_ID} .vayana-thumbnails {
        grid-column: 1;
        grid-row: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      #${CUSTOM_ID} .vayana-thumb {
        width: 82px;
        padding: 0;
        border: 2px solid transparent;
        border-radius: 8px;
        background: transparent;
        cursor: pointer;
        overflow: hidden;
      }

      #${CUSTOM_ID} .vayana-thumb.is-active {
        border-color: #222;
      }

      #${CUSTOM_ID} .vayana-thumb img {
        display: block;
        width: 100%;
        height: 100px;
        object-fit: cover;
      }

      @media screen and (max-width: 767px) {
        #${CUSTOM_ID} {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        #${CUSTOM_ID} .vayana-main {
          order: 1;
        }

        #${CUSTOM_ID} .vayana-thumbnails {
          order: 2;
          flex-direction: row;
          gap: 8px;
          width: 100%;
          overflow-x: auto;
          scrollbar-width: none;
        }

        #${CUSTOM_ID} .vayana-thumbnails::-webkit-scrollbar {
          display: none;
        }

        #${CUSTOM_ID} .vayana-thumb {
          flex: 0 0 72px;
          width: 72px;
        }

        #${CUSTOM_ID} .vayana-thumb img {
          height: 88px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function hideAllNativeGalleries() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {
      gallery.classList.add('vayana-native-hidden');
    });
  }

  function createGallery(nativeGalleries, allImages) {
    document.getElementById(CUSTOM_ID)?.remove();

    const targetGallery =
      nativeGalleries.find((gallery) => gallery.offsetParent !== null) ||
      nativeGalleries[0];

    if (!targetGallery) return;

    const customGallery = document.createElement('div');
    customGallery.id = CUSTOM_ID;

    const thumbnails = document.createElement('div');
    thumbnails.className = 'vayana-thumbnails';

    const main = document.createElement('div');
    main.className = 'vayana-main';

    const mainImage = document.createElement('img');
    mainImage.alt = '';

    main.appendChild(mainImage);
    customGallery.appendChild(thumbnails);
    customGallery.appendChild(main);

    targetGallery.parentNode.insertBefore(customGallery, targetGallery);

    hideAllNativeGalleries();

    let currentPrint = '';

    function showPrint(printName) {
      const matchingImages = allImages.filter(
        (image) => normalize(image.print) === normalize(printName)
      );

      if (!matchingImages.length) return;

      currentPrint = printName;
      thumbnails.innerHTML = '';

      function selectImage(imageData, button) {
        mainImage.src = imageData.src;
        mainImage.alt = imageData.print;

        if (imageData.srcset) {
          mainImage.srcset = imageData.srcset;
        } else {
          mainImage.removeAttribute('srcset');
        }

        thumbnails
          .querySelectorAll('.vayana-thumb')
          .forEach((thumb) => thumb.classList.remove('is-active'));

        button?.classList.add('is-active');
      }

      matchingImages.forEach((imageData, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vayana-thumb';
        button.setAttribute(
          'aria-label',
          `View ${imageData.print} image ${index + 1}`
        );

        const thumbnail = document.createElement('img');
        thumbnail.src = imageData.src;
        thumbnail.alt = imageData.print;
        thumbnail.loading = index === 0 ? 'eager' : 'lazy';

        button.appendChild(thumbnail);
        thumbnails.appendChild(button);

        button.addEventListener('click', () => {
          selectImage(imageData, button);
        });

        if (index === 0) {
          selectImage(imageData, button);
        }
      });
    }

    showPrint(getSelectedPrint() || allImages[0]?.print || '');

    document.addEventListener(
      'change',
      (event) => {
        if (!(event.target instanceof HTMLSelectElement)) return;

        const selectedOption =
          event.target.options[event.target.selectedIndex];

        if (
          normalize(selectedOption?.getAttribute('option-data')) === 'print'
        ) {
          const selectedPrint = selectedOption.textContent.trim();

          if (normalize(selectedPrint) !== normalize(currentPrint)) {
            showPrint(selectedPrint);
          }
        }
      },
      true
    );
  }

  function initialise() {
    const nativeGalleries = Array.from(
      document.querySelectorAll(GALLERY_SELECTOR)
    );

    if (!nativeGalleries.length) {
      setTimeout(initialise, 300);
      return;
    }

    const images = collectImages(nativeGalleries);

    if (!images.length) {
      setTimeout(initialise, 400);
      return;
    }

    addStyles();
    createGallery(nativeGalleries, images);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  window.addEventListener('load', () => {
    setTimeout(initialise, 500);
    setTimeout(hideAllNativeGalleries, 1200);
  });

  window.addEventListener('resize', () => {
    hideAllNativeGalleries();
  });
})();